module.exports = __webpack_public_path__ + "img/ic-upload-lable.5bfc21e3.svg";